@let filteredAssets = filteredAssets$ | async;

@if (filteredAssets !== null) {
    <div class="loren-home">
        <div class="loren-home-parameters">
            <loren-parameter-card
                    svgIcon="status-error"
                    [name]="'home.critical_alarms' | transloco"
                    [value]="criticalAlarms()"
                    (click)="filterAlarmsTable('critical')"/>
            <loren-parameter-card
                    svgIcon="status-warning"
                    [name]="'home.warning_alarms' | transloco"
                    [value]="warningAlarms()"
                    (click)="filterAlarmsTable('warning')"/>
            <loren-parameter-card
                    svgIcon="active-devices"
                    [name]="'home.assets' | transloco"
                    [value]="filteredAssets.length"
                    (click)="navigateTo(routes.ASSETS_LIST)"/>
        </div>
        <home-asset-map [assets]="filteredAssets"/>
        <loren-home-map [assets]="filteredAssets"/>
        <loren-home-selected-assets [assets]="filteredAssets"/>
        <loren-home-alarms-table
            #alarmsTable
            [inputFilter]="alarmsFilter()"
            [assets]="filteredAssets"
            (filtersCleared)="alarmsFilter.set(null)"/>
    </div>
} @else {
    <loren-page-content>
        <mat-spinner/>
    </loren-page-content>
}